(function () {
  function init(root) {
    if (!root || root.dataset.oelInfoRowsReady === 'true') return;
    root.dataset.oelInfoRowsReady = 'true';

    var links = root.querySelectorAll('[data-oel-info-row-link]');
    if (!links.length) return;

    var files = {};
    var script = root.querySelector('[data-oel-info-row-files]');
    if (script) {
      try {
        files = JSON.parse(script.textContent);
      } catch (e) {}
    }

    var fallback = root.getAttribute('data-fallback-url') || '';

    function apply(variantId) {
      var url = files[String(variantId)] || fallback;
      links.forEach(function (link) {
        if (url) {
          link.setAttribute('href', url);
          link.removeAttribute('hidden');
        } else {
          link.setAttribute('hidden', '');
        }
      });
    }

    var section = root.closest('[data-section-type="product"]') || document;
    section.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant) apply(variant.id);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-oel-info-rows]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
